import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { BulletinMachineStateDescriptor } from './model/bulletin';

@Injectable()
export class BulletinMachineService extends RESTServiceBase {

  constructor(authService: AuthService, config: AppConfig) {
    super(
      'v1',
      'BulletinMachineManagement',
      authService,
      config.BMSConfig
    );
  }

  public async getExpectedStates(bulletinId: string): Promise<BulletinMachineStateDescriptor[]> {
    return super.get<BulletinMachineStateDescriptor[]>(bulletinId);
  }

  public async set(bulletinId: string, state: BulletinMachineStateDescriptor): Promise<void> {
    return super.patch<any>(bulletinId, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/bulletin/bulletin.machine.service.ts